import React from 'react';

/**
 * High-fidelity 12 Zodiac Sign Vector SVG Badges matching the reference image
 * (Detailed figurative illustrations: Ram, Bull, Twins, Crab, Lion, Maiden, Scales,
 *  Scorpion, Centaur Archer, Sea-Goat, Water Bearer, Two Koi Fishes)
 */
export const ZodiacIcon = ({ name, iconKey, size = 52, className = '' }) => {
  const key = (iconKey || name || '').toLowerCase();

  const getIconData = () => {
    switch (key) {
      case 'aries':
      case 'మేషం':
        return {
          bg: '#5CB85C',
          svg: (
            <svg viewBox="0 0 100 100" width="76%" height="76%" fill="white">
              {/* Detailed Ram */}
              <path d="M72,32 C70,24 62,20 54,20 C42,20 33,28 32,40 C31,44 32,48 34,51 C32,50 30,48 29,45 C27,40 28,34 31,29 C34,25 39,22 44,21 C42,18 37,16 32,17 C24,19 18,26 18,35 C18,46 26,56 36,58 C38,59 40,59 42,58 L42,66 L38,76 L44,76 L48,67 L56,67 L60,76 L66,76 L61,64 C67,61 72,55 74,48 C76,43 75,37 72,32 Z M54,26 C59,26 64,29 66,34 C63,35 60,38 58,41 C54,36 49,32 44,30 C46,27 50,26 54,26 Z M38,40 C38,34 43,28 49,27 C54,29 58,33 60,38 C56,43 51,46 45,46 C41,46 39,43 38,40 Z" />
              <circle cx="49" cy="35" r="2.5" fill="#5CB85C" />
            </svg>
          ),
        };

      case 'taurus':
      case 'వృషభం':
        return {
          bg: '#D32F2F',
          svg: (
            <svg viewBox="0 0 100 100" width="76%" height="76%" fill="white">
              {/* Detailed Charging Bull */}
              <path d="M76,28 C74,22 69,18 63,16 C65,21 64,26 61,30 C58,33 54,34 50,33 C46,34 42,33 39,30 C36,26 35,21 37,16 C31,18 26,22 24,28 C21,34 22,42 27,47 C25,50 23,54 22,58 C20,66 24,74 32,77 L34,84 L40,84 L40,78 C43,79 47,80 50,80 C53,80 57,79 60,78 L60,84 L66,84 L68,77 C76,74 80,66 78,58 C77,54 75,50 73,47 C78,42 79,34 76,28 Z M34,24 C37,27 38,32 37,36 C32,34 29,29 30,24 C31,24 33,24 34,24 Z M70,24 C71,29 68,34 63,36 C62,32 63,27 66,24 C67,24 69,24 70,24 Z M50,72 C41,72 34,65 34,56 C34,48 40,42 47,41 L47,47 L53,47 L53,41 C60,42 66,48 66,56 C66,65 59,72 50,72 Z" />
              <circle cx="43" cy="54" r="2.5" fill="#D32F2F" />
              <circle cx="57" cy="54" r="2.5" fill="#D32F2F" />
              <path d="M46,63 C48,65 52,65 54,63" stroke="#D32F2F" strokeWidth="2" strokeLinecap="round" fill="none" />
            </svg>
          ),
        };

      case 'gemini':
      case 'మిధునం':
        return {
          bg: '#D81B60',
          svg: (
            <svg viewBox="0 0 100 100" width="76%" height="76%" fill="white">
              {/* Detailed Gemini Twins */}
              <circle cx="36" cy="24" r="8" />
              <circle cx="64" cy="24" r="8" />
              <path d="M26,44 C26,36 32,34 36,34 C40,34 46,36 46,44 L46,62 L42,80 L32,80 L30,62 L26,62 Z" />
              <path d="M54,44 C54,36 60,34 64,34 C68,34 74,36 74,44 L74,62 L70,80 L60,80 L58,62 L54,62 Z" />
              {/* Interlinked arms */}
              <path d="M38,44 C45,46 55,46 62,44 C64,48 60,54 50,54 C40,54 36,48 38,44 Z" fill="white" />
              <path d="M22,46 L28,60 L24,62 L18,48 Z" />
              <path d="M78,46 L72,60 L76,62 L82,48 Z" />
            </svg>
          ),
        };

      case 'cancer':
      case 'కర్కాటకం':
        return {
          bg: '#303F9F',
          svg: (
            <svg viewBox="0 0 100 100" width="76%" height="76%" fill="white">
              {/* Detailed Crab */}
              <ellipse cx="50" cy="56" rx="20" ry="15" />
              {/* Big Pincers Left */}
              <path d="M32,48 C24,44 18,36 18,26 C26,26 34,32 36,40 C34,32 40,24 48,22 C44,32 38,42 32,48 Z" />
              {/* Big Pincers Right */}
              <path d="M68,48 C76,44 82,36 82,26 C74,26 66,32 64,40 C66,32 60,24 52,22 C56,32 62,42 68,48 Z" />
              {/* Walking Legs Left */}
              <path d="M32,58 C22,58 16,64 14,72 L18,73 C20,67 24,62 32,62 Z" />
              <path d="M34,66 C26,68 20,76 20,84 L24,84 C24,78 28,72 35,70 Z" />
              {/* Walking Legs Right */}
              <path d="M68,58 C78,58 84,64 86,72 L82,73 C80,67 76,62 68,62 Z" />
              <path d="M66,66 C74,68 80,76 80,84 L76,84 C76,78 72,72 65,70 Z" />
              {/* Eyes */}
              <circle cx="44" cy="43" r="3" fill="white" />
              <circle cx="56" cy="43" r="3" fill="white" />
              <circle cx="44" cy="43" r="1.5" fill="#303F9F" />
              <circle cx="56" cy="43" r="1.5" fill="#303F9F" />
            </svg>
          ),
        };

      case 'leo':
      case 'సింహం':
        return {
          bg: '#EC407A',
          svg: (
            <svg viewBox="0 0 100 100" width="76%" height="76%" fill="white">
              {/* Detailed Lion with mane */}
              <path d="M50,16 C36,16 22,26 20,42 C18,52 22,64 30,72 C36,78 44,82 50,84 C56,82 64,78 70,72 C78,64 82,52 80,42 C78,26 64,16 50,16 Z M50,22 C61,22 72,30 74,42 C75,50 71,58 66,64 C64,58 60,54 54,52 C58,49 60,44 60,39 C60,32 55,27 48,27 C44,27 41,29 39,32 C37,28 33,26 28,27 C24,28 22,32 23,36 C22,42 24,48 28,52 C22,56 19,63 21,70 C17,62 17,50 20,42 C22,30 35,22 50,22 Z M50,44 C53,44 55,46 55,49 C55,54 48,58 46,62 C44,58 41,56 38,56 C36,56 34,57 33,59 C32,54 36,48 41,46 C44,45 47,44 50,44 Z" />
              <circle cx="42" cy="41" r="2.5" fill="#EC407A" />
              <circle cx="58" cy="41" r="2.5" fill="#EC407A" />
              <path d="M47,54 L53,54 L50,58 Z" fill="#EC407A" />
              <path d="M45,66 C48,69 52,69 55,66" stroke="white" strokeWidth="2.5" strokeLinecap="round" fill="none" />
            </svg>
          ),
        };

      case 'virgo':
      case 'కన్య':
        return {
          bg: '#1A237E',
          svg: (
            <svg viewBox="0 0 100 100" width="76%" height="76%" fill="white">
              {/* Detailed Maiden / Virgo profile with flowing hair */}
              <circle cx="48" cy="24" r="8" />
              {/* Flowing hair & wings */}
              <path d="M38,20 C34,24 32,32 30,42 C26,40 22,42 20,48 C18,56 22,66 28,74 C30,76 34,70 34,64 C34,56 36,46 40,40 C42,46 44,54 44,66 L40,82 L54,82 L56,62 C58,54 60,46 62,40 C66,48 72,58 78,64 C80,60 82,54 80,48 C76,40 70,34 64,30 C60,26 54,20 48,20 L38,20 Z" />
              {/* Wheat / palm branch */}
              <path d="M64,48 Q72,42 76,34 M68,44 Q74,38 78,38 M66,50 Q74,50 80,46" stroke="white" strokeWidth="2.5" strokeLinecap="round" fill="none" />
            </svg>
          ),
        };

      case 'libra':
      case 'తుల':
        return {
          bg: '#00897B',
          svg: (
            <svg viewBox="0 0 100 100" width="76%" height="76%" fill="white">
              {/* Lady/Figure holding Balance Scales */}
              <circle cx="50" cy="20" r="6" />
              <path d="M46,30 L54,30 L56,54 L44,54 Z" />
              <path d="M44,54 L40,80 L60,80 L56,54 Z" />
              {/* Scales Beam */}
              <rect x="18" y="36" width="64" height="4" rx="2" />
              <circle cx="50" cy="38" r="4" />
              {/* Left Pan */}
              <path d="M22,40 L16,56 L34,56 Z" fill="none" stroke="white" strokeWidth="2" />
              <path d="M14,56 C14,64 36,64 36,56 Z" />
              {/* Right Pan */}
              <path d="M78,40 L72,56 L90,56 Z" fill="none" stroke="white" strokeWidth="2" />
              <path d="M70,56 C70,64 92,64 92,56 Z" />
            </svg>
          ),
        };

      case 'scorpio':
      case 'వృశ్చికం':
        return {
          bg: '#E65100',
          svg: (
            <svg viewBox="0 0 100 100" width="76%" height="76%" fill="white">
              {/* Detailed Scorpion */}
              {/* Pincers */}
              <path d="M38,42 C30,38 24,30 22,20 C30,20 38,26 40,34 C36,28 42,22 50,20 C46,28 42,36 38,42 Z" />
              <path d="M62,42 C70,38 76,30 78,20 C70,20 62,26 60,34 C64,28 58,22 50,20 C54,28 58,36 62,42 Z" />
              {/* Body segments */}
              <ellipse cx="50" cy="46" rx="9" ry="6" />
              <ellipse cx="50" cy="54" rx="8" ry="5" />
              <ellipse cx="50" cy="62" rx="7" ry="5" />
              {/* Tail curving up and sting */}
              <path d="M50,66 C50,74 56,82 66,82 C74,82 80,76 80,68 C80,60 74,56 68,58 L72,52 L62,54 C66,60 74,62 72,68 C70,72 66,74 62,72 C56,70 54,64 54,60 Z" />
              {/* Sting Barb */}
              <path d="M62,54 L68,46 L70,54 Z" />
              {/* Side legs */}
              <path d="M42,48 L28,46 L24,52 M42,54 L26,56 L22,64 M42,60 L28,66 L26,74" stroke="white" strokeWidth="2.2" strokeLinecap="round" fill="none" />
              <path d="M58,48 L72,46 L76,52 M58,54 L74,56 L78,64 M58,60 L72,66 L74,74" stroke="white" strokeWidth="2.2" strokeLinecap="round" fill="none" />
            </svg>
          ),
        };

      case 'sagittarius':
      case 'ధనుస్సు':
        return {
          bg: '#388E3C',
          svg: (
            <svg viewBox="0 0 100 100" width="76%" height="76%" fill="white">
              {/* Detailed Centaur Archer */}
              {/* Horse body & legs */}
              <path d="M48,56 C44,52 38,50 30,52 C22,54 18,60 16,68 L22,82 L28,82 L28,72 C32,70 38,70 42,72 L44,82 L50,82 L52,66 Z" />
              <path d="M16,62 C12,66 10,74 12,80 L16,80 C15,74 18,68 20,64 Z" />
              {/* Human Torso */}
              <path d="M46,44 C44,38 46,32 50,28 C52,24 56,22 60,22 C64,22 68,26 66,32 C64,38 60,42 56,46 L54,58 L46,58 Z" />
              <circle cx="60" cy="20" r="5" />
              {/* Bow & Arrow */}
              <path d="M56,16 Q78,36 84,58" stroke="white" strokeWidth="3" strokeLinecap="round" fill="none" />
              <path d="M56,16 L70,44 L84,58" stroke="white" strokeWidth="1.2" strokeLinecap="round" fill="none" />
              {/* Aiming arrow */}
              <line x1="42" y1="46" x2="86" y2="24" stroke="white" strokeWidth="3" strokeLinecap="round" />
              <polygon points="86,20 88,28 80,25" fill="white" />
            </svg>
          ),
        };

      case 'capricorn':
      case 'మకరం':
        return {
          bg: '#EF6C00',
          svg: (
            <svg viewBox="0 0 100 100" width="76%" height="76%" fill="white">
              {/* Detailed Sea-Goat (horned goat front, curled fish tail) */}
              <path d="M44,28 C42,20 46,14 52,14 C56,14 60,18 58,24 C56,20 52,18 48,20 C46,22 46,26 48,30 L52,36 C56,36 60,40 60,46 C60,52 56,58 50,60 L48,70 L42,70 L44,58 C38,58 32,62 30,68 C28,76 34,84 44,84 C56,84 68,76 74,66 C78,58 76,48 70,42 L72,36 C80,44 84,56 80,68 C74,82 58,90 42,90 C28,90 20,80 22,68 C24,56 34,48 44,46 L42,38 C38,38 34,34 36,28 C38,22 44,20 48,22 Z" />
              {/* Horn ridges */}
              <path d="M48,20 Q56,24 58,32" stroke="#EF6C00" strokeWidth="1.5" fill="none" />
              {/* Fish Tail Fin */}
              <path d="M72,40 C78,34 84,32 88,34 C86,40 82,44 76,46 Z" />
              <path d="M74,44 C80,46 86,50 88,56 C82,54 78,50 74,46 Z" />
            </svg>
          ),
        };

      case 'aquarius':
      case 'కుంభం':
        return {
          bg: '#C62828',
          svg: (
            <svg viewBox="0 0 100 100" width="76%" height="76%" fill="white">
              {/* Water Bearer pouring water urn */}
              <circle cx="36" cy="22" r="6" />
              {/* Kneeling figure */}
              <path d="M30,32 C30,28 36,28 40,32 L46,42 L42,58 L48,72 L54,72 L50,82 L36,82 L34,68 L36,54 L28,40 Z" />
              {/* Water Urn / Pitcher */}
              <ellipse cx="56" cy="38" rx="10" ry="8" transform="rotate(-30 56 38)" />
              <path d="M50,30 L64,38 L60,46 L46,38 Z" />
              <path d="M64,38 C68,42 74,44 76,48 L70,52 C68,48 64,46 60,46 Z" />
              {/* Flowing water waves */}
              <path d="M68,48 Q76,56 70,64 T72,80" stroke="white" strokeWidth="4" strokeLinecap="round" fill="none" />
              <path d="M76,52 Q84,60 78,68 T80,84" stroke="white" strokeWidth="3" strokeLinecap="round" fill="none" />
              <path d="M62,54 Q68,62 64,70 T66,82" stroke="white" strokeWidth="2.5" strokeLinecap="round" fill="none" />
            </svg>
          ),
        };

      case 'pisces':
      case 'మీనం':
      default:
        return {
          bg: '#2E7D32',
          svg: (
            <svg viewBox="0 0 100 100" width="76%" height="76%" fill="white">
              {/* Two Koi Fishes swimming in a circle */}
              {/* Fish 1 (swimming down-right) */}
              <path d="M36,20 C46,18 56,22 62,30 C64,34 62,38 58,40 C52,42 44,40 38,34 C34,30 32,24 36,20 Z" />
              <path d="M36,20 C32,16 26,16 22,20 C26,22 28,26 28,30 C24,30 20,28 18,24 C18,32 26,34 32,32 Z" />
              {/* Fish 2 (swimming up-left) */}
              <path d="M64,80 C54,82 44,78 38,70 C36,66 38,62 42,60 C48,58 56,60 62,66 C66,70 68,76 64,80 Z" />
              <path d="M64,80 C68,84 74,84 78,80 C74,78 72,74 72,70 C76,70 80,72 82,76 C82,68 74,66 68,68 Z" />
              {/* Connecting Ribbon / Stream */}
              <path d="M48,32 C58,40 58,60 48,68" stroke="white" strokeWidth="2.5" strokeDasharray="3,3" fill="none" />
              <path d="M52,32 C42,40 42,60 52,68" stroke="white" strokeWidth="2.5" strokeDasharray="3,3" fill="none" />
            </svg>
          ),
        };
    }
  };

  const iconInfo = getIconData();

  return (
    <div
      className={`zodiac-badge ${className}`}
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        backgroundColor: iconInfo.bg,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
      }}
    >
      {iconInfo.svg}
    </div>
  );
};

export default ZodiacIcon;
